import { exchangeJwtForBadgeToken } from '../auth/authenticateFromOauth';
import { isJWT } from './authDetection';

const parseJwtPayload = (jwt: string): { id?: number } => {
  try {
    const payload = jwt.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Failed to parse JWT:', error);
    return {};
  }
};

/**
 * Gets a one-time token for public reware-api calls.
 *
 * @param providedToken - Optional token to use instead of sessionStorage
 * @returns Promise resolving to the badge token to use for API calls
 */
export const getApiToken = async (providedToken?: string): Promise<string> => {
  const token = providedToken || sessionStorage.getItem('token');

  if (!token) {
    throw new Error('No authentication token found');
  }

  const cachedBadgeToken = sessionStorage.getItem('badgeToken');
  if (cachedBadgeToken) {
    return cachedBadgeToken;
  }

  if (!isJWT(token)) {
    sessionStorage.setItem('badgeToken', token);
    return token;
  }

  const payload = parseJwtPayload(token);
  if (!payload.id) {
    throw new Error('Invalid JWT: missing user ID');
  }

  const badgeToken = await exchangeJwtForBadgeToken({
    token,
    userId: payload.id,
  });

  // Cache the badge token
  sessionStorage.setItem('badgeToken', badgeToken);

  return badgeToken;
};